export const startBrowserErrorTracker = (options) => {
    patchGlobalErrorCallbacks(options);
};
let isDriverLoaded = false;
let isDriverLoading = false;
let _originalOnError;
let _originalOnUnhandledRejection;
const errorQueue = (options, content) => {
    errorQueue.data.push(content);
    if (isDriverLoading || isDriverLoaded) {
        return;
    }
    isDriverLoaded = false;
    isDriverLoading = true;
    const loadDriver = options.driver === 'sentry' ? loadSentry : loadRollbar;
    loadDriver(options)
        .then(driver => {
        for (const data of errorQueue.data) {
            driver.captureException(data.error);
        }
        errorQueue.data = [];
        restoreGlobalErrorCallbacks();
        isDriverLoaded = true;
        isDriverLoading = false;
    })
        .catch(() => {
        restoreGlobalErrorCallbacks();
        isDriverLoaded = false;
        isDriverLoading = false;
    });
};
function patchGlobalErrorCallbacks(options) {
    _originalOnError = window.onerror;
    _originalOnUnhandledRejection = window.onunhandledrejection;
    window.onerror = function (_message, _url, _line, _column, error) {
        errorQueue(options, {
            type: 'error',
            error
        });
        if (_originalOnError) {
            _originalOnError.apply(window, arguments);
        }
    };
    window.onunhandledrejection = function (event) {
        errorQueue(options, {
            type: 'promise',
            error: event.reason
        });
        if (_originalOnUnhandledRejection) {
            _originalOnUnhandledRejection.apply(window, arguments);
        }
    };
}
const restoreGlobalErrorCallbacks = () => {
    window.onerror = _originalOnError;
    window.onunhandledrejection = _originalOnUnhandledRejection;
};
const loadSentry = async ({ appEnv, sentryDsn, sentryRelease, sentryOptions }) => {
    const Sentry = await import('@sentry/browser');
    Sentry.init({
        dsn: sentryDsn,
        environment: appEnv,
        release: sentryRelease,
        enableTracing: false,
        tracesSampleRate: 1,
        ...sentryOptions
    });
    return {
        captureException: (error) => Sentry.captureException(error)
    };
};
const loadRollbar = async ({ appEnv, rollbarAccessToken, rollbarRelease, rollbarOptions }) => {
    var _a, _b;
    const Rollbar = await import('rollbar').then(m => m.default);
    const rollbar = new Rollbar({
        accessToken: rollbarAccessToken,
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: appEnv,
        payload: {
            environment: appEnv,
            client: {
                javascript: {
                    ...(_b = (_a = rollbarOptions === null || rollbarOptions === void 0 ? void 0 : rollbarOptions.payload) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.javascript,
                    code_version: rollbarRelease,
                    source_map_enabled: true,
                    guess_uncaught_frames: true
                }
            }
        },
        ...rollbarOptions
    });
    return {
        captureException: (error) => rollbar.error(error)
    };
};
errorQueue.data = [];
